import axios from 'axios';
import prepareRequestOptions from '../utils/admin-apis.util';

export const getListData = async (params = '', signal = null) => {
  const options = prepareRequestOptions(
    `/admin/subscribers/list${params}`,
    'GET',
    null,
    true,
    signal
  );

  const response = await axios(options);
  return response.data;
};

export const createNewData = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/subscribers/create',
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const viewDataById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/subscribers/${id}/view`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const updateDataById = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/subscribers/${id}/update`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const deleteDataById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/subscribers/${id}/delete`,
    'DELETE',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const updatePasswordById = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/subscribers/${id}/update-password`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getSearchListData = async (params = '') => {
  const options = prepareRequestOptions(
    `/admin/subscribers/search-list${params}`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getSubscriptionsListData = async (
  id,
  params = '',
  signal = null
) => {
  const options = prepareRequestOptions(
    `/admin/subscribers/${id}/subscriptions/list${params}`,
    'GET',
    null,
    true,
    signal
  );

  const response = await axios(options);
  return response.data;
};
